import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { domainUrl } from '../../../constants'
import { checkAuthorization } from '../../../helpers';
import { message } from 'antd'

export const getServiceApi = createAsyncThunk('getserviceStatistics',
    async (object, { dispatch, getState }) => {

        const {userToken}= checkAuthorization()
        dispatch(gettingServiceDetail())
        var myHeaders = new Headers();
        myHeaders.append("Authorization", userToken)
        myHeaders.append("Content-Type", "application/json")
        myHeaders.append("pageNO", object?.pageNo)
        myHeaders.append("recordsPerPage", object?.pageSize)
        var requestOptions = {
            method: 'Post',
            headers: myHeaders,
            redirect: 'follow',
            body: JSON.stringify({name: object?.name})
        };
        fetch(domainUrl + `/viewAllServices`, requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result?.success) {
                    dispatch(serviceDetailResponse(result?.data))
                    dispatch(setPages({pageNo: object?.pageNo, pageSize: object?.pageSize, totalRecords: result?.totalRecords}))
                }
                else 
                    throw result?.message
            })
            .catch(error => { 
                dispatch(serviceDetailClear())
                message.error(error) 
            })
    }
)


export const updateServiceStatus = createAsyncThunk('getStatusStatistics',
    async (object, { dispatch, getState }) => {

        const { userToken } = checkAuthorization()
        var myHeaders = new Headers();
        myHeaders.append("Authorization", userToken)
        myHeaders.append("Content-Type", "application/json")
        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            redirect: 'follow',
            body: JSON.stringify({ id: object?.id, status: object?.status })
        };
        fetch(domainUrl + `/updateServiceStatus`, requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result?.success) {
                    const data = result?.data;
                    dispatch(servicestatusResponse({id: data?.id, status: data?.status}))
                }
                else
                    throw result?.message
            })
            .catch(error => {
                message.error(error)
            })
    }
)


const GetServiceApiSlice = createSlice({
    name: 'ServiceApi',
    initialState: {
        serviceData: null,
        loadingservice: false,
        pagination:{
            pageNo:1,
            pageSize: 10,
            totalRecords:0,
        },
        filters: {
            name: '',
            id: '',
            status: '',
        },
    },
    reducers: {
        gettingServiceDetail: state => {
            state.loadingservice=true
            state.serviceData=null
        },
        serviceDetailResponse: (state, action)=>{
            state.serviceData= action.payload
            state.loadingservice= false
        },
        serviceDetailClear: (state)=>{
            state.serviceData= null
            state.loadingservice= false
        },
        changeServiceDetailFilters: (state, action) => {
            state.filters = action.payload
        },
        setPages:(state, action)=>{
            state.pagination= action.payload
        },
        servicestatusResponse: (state, action) => {
            const { id, status } = action.payload
            const serviceIndex = state.serviceData.findIndex(ser => ser.id === id)
            if (serviceIndex !== -1) {
                state.serviceData[serviceIndex].status = status
            }
            state.loadingservice = false
        }
    },
})
export const { 
    gettingServiceDetail, serviceDetailResponse, serviceDetailClear,
    changeServiceDetailFilters, setPages, servicestatusResponse
} = GetServiceApiSlice.actions;
export default GetServiceApiSlice.reducer;